import React, { useEffect, useState } from "react";

// 부모 컴포넌트로부터 'onClose' 함수와 'children'을 props로 받습니다.
function MainPopup({ onClose, onHideToday, children }) {
  return (
    <div className='main-popup'>
      {/* 팝업 배경 (어두운 오버레이) */}
      <div className="popup-overlay">
        <div className="popup-content">
          {/* 닫기 버튼 */}
          <button className="close-button" onClick={onClose}>
            &times; {/* 'X' 모양의 특수문자 */}
          </button>
          {/* 부모 컴포넌트에서 전달한 내용. */}
          {children}
        </div>
        <div className="popup-footer">
          {/* "오늘 하루 보지 않기" 버튼 */}
          <button onClick={onHideToday}>
            오늘 하루 동안 보지 않기 &times;
          </button>
        </div>
      </div>
    </div>
  );
}

export default MainPopup;